export const sortArchivedThenByName = (a: any, b: any): number => {
  if (a.archived > b.archived) {
    return 1;
  }

  if (a.archived < b.archived) {
    return -1;
  }

  return a.name.localeCompare(b.name);
};
